import HelperMixin from "@/mixins/HelperMixin";
import ValidateMixin from '@/mixins/ValidateMixin';
import AppButton from "@/components/AppButton";
import AppIcon from "@/components/AppIcon";
import PpcBudgetAllocationWeeklyBudgetInput from "@/components/PpcBudgetAllocationWeeklyBudgetInput";
import PpcBudgetAllocationWeeklyBudgetCampaign from "@/components/PpcBudgetAllocationWeeklyBudgetCampaign";
import { CurrencyValue } from "@/components/tableElements";
import BarChartIcon from "@/components/icons/BarChartIcon";
import CalendarWithArrowLeftIcon from "@/components/icons/CalendarWithArrowLeftIcon";
export default {
  name: "PpcBudgetAllocationWeeklyBudgetCampaignBody",
  mixins: [HelperMixin, ValidateMixin],
  emits: ["update"],
  components: {
    AppButton,
    AppIcon,
    PpcBudgetAllocationWeeklyBudgetInput,
    PpcBudgetAllocationWeeklyBudgetCampaign,
    CurrencyValue,
    BarChartIcon,
    CalendarWithArrowLeftIcon
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    budgetCurrent: {
      type: Number
    },
    potential: {
      type: Number
    },
    open: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String
    },
    country_code: {
      type: String
    },
    advanced: {
      type: Boolean,
      default: false
    },
    validationMultiplier: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      localModel: this.budgetCurrent,
      localModelPotential: this.potential * 100
    };
  },
  watch: {
    budgetCurrent(value) {
      this.localModel = value;
      this.localModelPotential = (this.localModel / this.data.budgetPotential ?? 1) * 100;
    }
  },
  computed: {
    validation() {
      return this.getValidation();
    }
  },
  methods: {
    getValidation() {
      return this.mValidatePPCBudgetWeekly(this.localModel, this.country_code, this.advanced ? 1 : this.validationMultiplier);
    },
    onInputUpdateBudget(value) {
      this.localModel = value;
      this.localModelPotential = (this.localModel / this.data.budgetPotential ?? 1) * 100;
      this.$emit("update", this.localModel);
    },
    onInputUpdatePotential(value) {
      this.localModel = this.data.budgetPotential * value / 100;
      this.$emit("update", this.localModel);
    }
  }
};